import { render, staticRenderFns } from "./DiverseEditLedger.vue?vue&type=template&id=79051430&scoped=true"
import script from "./DiverseEditLedger.vue?vue&type=script&lang=ts"
export * from "./DiverseEditLedger.vue?vue&type=script&lang=ts"
import style0 from "./DiverseEditLedger.vue?vue&type=style&index=0&id=79051430&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79051430",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79051430')) {
      api.createRecord('79051430', component.options)
    } else {
      api.reload('79051430', component.options)
    }
    module.hot.accept("./DiverseEditLedger.vue?vue&type=template&id=79051430&scoped=true", function () {
      api.rerender('79051430', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bookkeeping/DiverseEditLedger.vue"
export default component.exports